import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.25 10.512a8.25 8.25 0 1 1 14.59 5.279l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69a8.25 8.25 0 0 1-13.53-6.34m8.25-6.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }